/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment'

import { Divider } from 'primereact/divider';

import './style.scss'

class Log extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMaximize: false,
      name: '',
      reason: ''
    }
  }

  componentDidMount() {
    const { message } = this.props
    if (message) {
      const splitMessage = message.split('||')
      const getName = splitMessage[0]
      const getReason = splitMessage[1]
      this.setState({
        name: getName,
        reason: getReason
      })
    }
  }

  splitMessage  = (message) => {
    if (message && message.length > 20) {
      return `${message.slice(0,20)}...`
    }
    return message
  }

  onGetAction = () => {
    const { transactionNameCatalog, action, category } = this.props
    const getCateogy = transactionNameCatalog.find(item => item.categoria === category)
    const getAction = getCateogy.acciones.find(item => item.transaccion === action)
    return getAction?.nombre || ''
  }
  
  render () {

    const {
      timestamp,
      userEmail,
      userRole,
      t
    } = this.props

    const { isMaximize, name, reason } = this.state

    return (
      <div className={classNames('p-grid log-container', {
        'log-container-active': isMaximize
      })}>
        <div className='p-col-12 cursor-pointer p-pl-4 p-grid' onClick={() => this.setState({isMaximize: !isMaximize})}>
          <div className='p-col-4'>
            <h5 className='p-text-bold'>{timestamp ? moment(timestamp).format('DD-MM-YYYY HH:mm:ss'): ''}</h5>
          </div>
          <div className='p-col-4'>
            <h5 className=''>{this.onGetAction()}</h5>
          </div>
          <div className='p-col-4'>
            <h5 className='text-message'>{this.splitMessage(name)}</h5>
          </div>
        </div>
        { isMaximize && (
          <div className='p-col-12 p-grid p-pl-4 log-description-container'>
            <div className='p-col-12'>
              <h4 className=''><i className="pi pi-fw pi-ticket" style={{'fontSize': '25px'}}/> {this.onGetAction()}</h4>
            </div>
            <div className='p-col-4'>
              <label className='p-text-bold p-pb-4'>{t('Nombre')}</label>
              <p>{name}</p>
            </div>
            <div className='p-col-4'>
              <label className='p-text-bold p-pb-4'>{t('Justificación')}</label>
              <p>{reason}</p>
            </div>
            <div className='p-col-4'>
              <label className='p-text-bold p-pb-4'>{t('Correo de usuario')}</label>
              <p>{userEmail}</p>
            </div>
            <div className='p-col-4'>
              <label className='p-text-bold p-pb-4'>{t('Rol de usuario')}</label>
              <p>{userRole}</p>
            </div>
          </div>
        )}
        <Divider className='p-mb-0'/>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  transactionNameCatalog: state.catalogs.transactionNameCatalog,
});

const mapDispatchToProps = {
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps))(Log)